<template>
  <div class="animal-card rehome__item">
     <a :href="animal.uri">
       <img :src="animal.animalImages[0].url" :alt="animal.title" v-if="animal.animalImages.length">
       <img :src="'https://dummyimage.com/380x286/fff/000?text=Photo of '+animal.title+' Coming Soon'" :alt="animal.title+' placeholder image'" v-else>
       <div class="status" v-if="status">{{ status }}</div>
       <p>{{ animal.title }}</p>
      </a>
  </div>
</template>

<script>
export default {
  props: {
    animal: {
      required: true,
      type: Object,
    },
  },
  computed: {
    status() {
      switch (this.animal.status) {
        case 'reserved':
           return 'Reserved'
        case 'closed':
          return 'Applications closed'
        break;
      }

    }
  }
}
</script>






